/**
 * Guest tags
 */
import { hideShowNoDataFound } from "./common";

window.$(function () {

    // Append table with add row form on add new button click
    window.$(".guest_tag .add-new").click(function(){
        window.$(this).attr("disabled", "disabled");

        var newRow = window.$(".new_guest_tag_tr tbody tr:first").html();
        window.$('.guest_table table tbody').prepend('<tr>'+newRow+'</tr>');
        window.$(".guest_table table tbody tr").eq(0).find(".add, .edit").toggle();
        window.$(".guest_table table tbody tr").eq(0).find(".remove").toggle();
        if(window.$('.guest_table table tbody').find('tr').length > 1){
            window.$('#no_data_avaiable').hide();
        }
    });

    // Add row on add button click
    window.$(document).on("click", ".guest_tag .add", function(e){
        e.preventDefault();
        window.toastr.remove();

        var thisTr = window.$(this).parents("tr");
        var data = thisTr.find('input').serialize();

        var guestTagId = thisTr.attr('id');

        var queryString = (typeof guestTagId !== "undefined" && guestTagId !== '') ? '/' + guestTagId : '';

        window.axios({
            method: queryString == ''? "post": "put",
            url: window.$("#guest_table").data('link') + queryString,
            data: data
        })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
                // Remove all span error
                window.$.each(response.data.data, function(key, value) {
                    window.$(thisTr).find('span.'+key+'-error').text('');
                });

                window.$(thisTr).attr("id", response.data.data.id);

                thisTr.find("td:eq(0) input[name='name_readonly']").val(response.data.data.name).removeAttr('hidden');
                thisTr.find("td:eq(0) input[name='name']").attr('hidden', true);

                window.$(".guest_tag .add-new").removeAttr("disabled");
                window.$(thisTr).find(".edit, .add").toggle();
                thisTr.find(".remove").toggle();
            })
            .catch(function(error) {
                if (error.response.status == 400) {
                    window.$.each(error.response.data, function(key, value) {
                        window.$(thisTr).find('span.'+key+'-error').text(value[0]);
                    });
                } else if (error.response.status == 500) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                }
            });
        return false;
    });

    // Edit row on edit button click
    window.$(document).on("click", ".guest_tag .edit", function(){
        window.$(".guest_tag .add-new").attr("disabled", "disabled");

        var thisTr = window.$(this).parents("tr");
        var guestTagId = thisTr.attr('id');
        thisTr.find("td:eq(0) input[name='name_readonly']").attr('hidden', true);
        thisTr.find("td:eq(0) input[name='name']").removeAttr('hidden');

        thisTr.append('<input hidden type="text" name="id" class="form-control" value="' + guestTagId + '">');
        thisTr.find(".add, .edit").toggle();

        // Add class 'cancel_edit' to get sense for cancel editing current row
        thisTr.addClass('cancel_edit');
        thisTr.find(".remove").toggle();
    });
    
    // change status of guest tag
    window.$('body').on('click', '.guest_tag .status_checkbox', function(e) {

        window.$(".error").html('');
        window.toastr.remove();

        var id = window.$(this).closest("tr").attr('id');
        if(typeof id !== "undefined" && id !== '') {
            var status = (window.$(this).is(':checked'))? 'on': '';
            let t = window.$(this);
            var queryString = '/' + id;

            window.axios({
                method: queryString == '' ? "post" : "put",
                url: window.$("#guest_table").data('link') + queryString,
                data: {
                    'id': id,
                    'status': status,
                    'update_status': true
                }
            })
                .then(function (response) {
                    window.toastr.success(response.data.message, response.statusText);
                }).catch(function(error) {
                    if (error.response.status == 401) {
                        window.toastr.error(error.response.data.message, error.response.statusText);
                        if(status == 'on'){
                            window.$(t).prop('checked',false);
                        }else if(status == ''){
                            window.$(t).prop('checked',true);
                        }
                    }
                })
        }
    });

    // Remove new tr for guest tag
    window.$('body').on("click", ".guest_tag .remove", function(){
        window.$(".guest_tag .add-new").removeAttr("disabled");

        var thisTr = window.$(this).parents("tr");

        // if cancel current editing row
        if(thisTr.hasClass('cancel_edit')) {
            thisTr.find("td:eq(0) input[name='name_readonly']").removeAttr('hidden');
            thisTr.find("td:eq(0) input[name='name']").attr('hidden', true);

            thisTr.find(".edit, .add").toggle();
            thisTr.find(".remove").toggle();
            if(window.$('.guest_table table tbody').find('tr').length > 1){
                window.$('#no_data_avaiable').hide();
            } else {
                window.$('#no_data_avaiable').show();
            }
            return true;
        }

        thisTr.remove();
        if(window.$('.guest_table table tbody').find('tr').length > 1){
            window.$('#no_data_avaiable').hide();
        } else {
            window.$('#no_data_avaiable').show();
        }
    });


});
